// MUI Imports
import type { Theme } from '@mui/material/styles'

/** One size/weight for normal copy; headings share one weight. Buttons/links use 600 in their components. */
const BODY_SIZE = '0.875rem'
const BODY_WEIGHT = 400
const BODY_LH = 1.5
const HEADING_WEIGHT = 600

const typography = (fontFamily: string): Theme['typography'] =>
  ({
    fontFamily:
      typeof fontFamily === 'undefined' || fontFamily === ''
        ? [
            'Inter',
            'sans-serif',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
          ].join(',')
        : fontFamily,
    fontSize: 14,
    h1: {
      fontSize: '2.875rem',
      fontWeight: HEADING_WEIGHT,
      lineHeight: 1.25,
    },
    h2: {
      fontSize: '2.375rem',
      fontWeight: HEADING_WEIGHT,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: HEADING_WEIGHT,
      lineHeight: 1.35,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: HEADING_WEIGHT,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: HEADING_WEIGHT,
      lineHeight: 1.45,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: HEADING_WEIGHT,
      lineHeight: 1.5,
    },
    subtitle1: {
      fontSize: BODY_SIZE,
      fontWeight: BODY_WEIGHT,
      lineHeight: BODY_LH,
    },
    subtitle2: {
      fontSize: BODY_SIZE,
      fontWeight: BODY_WEIGHT,
      lineHeight: BODY_LH,
    },
    body1: {
      fontSize: BODY_SIZE,
      fontWeight: BODY_WEIGHT,
      lineHeight: BODY_LH,
    },
    body2: {
      fontSize: BODY_SIZE,
      fontWeight: BODY_WEIGHT,
      lineHeight: BODY_LH,
    },
    button: {
      fontSize: BODY_SIZE,
      fontWeight: 600,
      lineHeight: BODY_LH,
      textTransform: 'none',
    },
    caption: {
      fontSize: BODY_SIZE,
      fontWeight: BODY_WEIGHT,
      lineHeight: BODY_LH,
      letterSpacing: 'normal',
    },
    overline: {
      fontSize: '0.75rem',
      fontWeight: BODY_WEIGHT,
      lineHeight: 1.25,
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
    },
  }) as Theme['typography']

export default typography
